import { IUserProfileOperations } from "./IUserProfileOperations";
import { IDataStore, DatabaseKey } from "../../repository/IDataStore";
import { IApi, EditUserRequest } from "../IApi";
import { IUser } from "../../model/ModelTypes";
import { flatMap, map } from "rxjs/operators";
import { Observable } from "rxjs";

export class UserProfileOperations implements IUserProfileOperations {
    
    private readonly dataStore: IDataStore;
    private readonly api: IApi;
    private user: IUser;
    public static GetOperations(dataStore: IDataStore, api: IApi): Observable<IUserProfileOperations> {
        return dataStore.getDocuments<Observable<IUser>>(DatabaseKey.user)
        .pipe(
            flatMap(item => item),
            map(
                user => {
                    let operations = new UserProfileOperations(dataStore, api);
                    operations.user = user;
                    return operations;
                }
            )
        );
    }
    editProfile(editedUser: IUser): Observable<IUser> {
        let storedUser: IUser;
        let user = this.user;
        let requestItem: EditUserRequest = {
            organisationCode: user.organisation,
            organisationUsername: user.username.split("-")[1]
        };
        if (editedUser.name !== user.name) {
            requestItem.name = editedUser.name;
        }
        if (editedUser.password !== user.password) {
            requestItem.password = editedUser.password;
            requestItem.confirmPassword = editedUser.password;
        }
        return this.api.editUser(requestItem).pipe(
            flatMap(
                updatedUser => {
                    storedUser = updatedUser;
                    return this.dataStore.insertDocument<IUser>(storedUser, DatabaseKey.user);
                }
            ),
            map(result => storedUser)
        );
    }
    private observeUser() {
        this.dataStore.getDocuments<Observable<IUser>>(DatabaseKey.user)
        .pipe(
            flatMap(item => item)
        )
        .subscribe(
            userItem => this.user = userItem
        );
    }
    private constructor(dataStore: IDataStore, api: IApi) {
        this.dataStore = dataStore;
        this.api = api;
        this.observeUser();
    }

}


// WEBPACK FOOTER //
// ./src/utility/public/UserProfileOperations.ts